import React from 'react';
//import {authRoles} from '../../auth';

export const VacacionesConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth : ['funcionario', 'rh', 'director'],
    routes  : [
        {
            path     : '/vacaciones',
            component: React.lazy(() => import('./Vacaciones'))
        }
    ]
};